/**
 * The report `/issue` is about to send (unit 26C): one at a time, held until
 * the person presses Submit or Cancel. In a store because the chat box opens
 * it and the frame shows it, once.
 */
import { create } from "zustand";

export interface Draft {
  report: string;
  /** The widget in front when it was typed, '' for none. */
  widget: string;
  /** Its tab, '' for none (`issue_reports.md` rule 1). */
  tab: string;
}

interface IssueStore {
  draft: Draft | null;
  open(draft: Draft): void;
  close(): void;
}

export const useIssue = create<IssueStore>()((set) => ({
  draft: null,
  open: (draft) => set({ draft }),
  close: () => set({ draft: null }),
}));

/** What the person is told before they send (Q4 (c); `issue_reports.md`
 * rules 2, 3): who reads what. */
export function whoReads(owner: boolean): string {
  return owner
    ? "GitHub gets your report, its context, the last 6 messages, their tool calls and your last actions: all of it is under “What GitHub gets”. All of the conversation stays in Kindred, in Executive, under Issues."
    : "The owner of this install will read your report, the conversation below, the agent’s tool calls and your last actions. GitHub gets your report and its context, with none of your words but the report. You cannot open this report again after you send it.";
}
